module.exports = __webpack_public_path__ + "img/320972864.07a10a46.jpg";